import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  number: "01",
  title: "Interview - Your WHY",
  description: "A comprehensive interview and review of your kennel's digital footprint and branding. We identify opportunities to better showcase your health-testing and pedigree excellence to help target families you want to work with."
}, {
  number: "02",
  title: "Content Curation",
  description: "Designing a digital home that reflects your 'Best in Show' standards, targeting the families and future puppy owners from your breeding program. We create a visual legacy that communicates prestige and heritage at first glance."
}, {
  number: "03",
  title: "WordPress & 10Web Tech",
  description: "Allows for a 30 day setup, instant editing/publishing, hosting (where needed), and ongoing management. With 10Web, we publicly highlight site building, managed hosting, backups, staging, speed optimization, and WooCommerce readiness. That helps you with confidence, security and flexibility of WordPress with a faster workflow for launch and updates from PupzStudio."
}, {
  number: "04",
  title: "Social Concierge",
  description: "Ongoing management of your digital reputation. From high-end social posting and editing to a well thought out content strategy with the ability to quickly update any achievements and celebrations. We maintain your status as a premier breeder year-round with planning and quick updates."
}];
export default function CooperationProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="36" id="whysystemworks" className="dark bg-background text-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium tracking-tight mb-6 text-primary">The Art and Science of Serenity</h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl font-sans tracking-wide">Just like your breeding program of Art and Science, our systematic approach transforms the lackluster and maybe haphazard of your digital presence and inquiries into a curated experience, ensuring your breeding program represents the highest of standards and image.</p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {steps.map((step, index) => <div key={index} className="group relative" data-index={index}>
              <Card className="h-full bg-transparent border-none shadow-none relative overflow-hidden pt-12 md:pt-16">
                {}
                <span className="absolute top-0 left-0 text-[8rem] md:text-[9rem] lg:text-[10rem] leading-none font-serif text-primary/5 select-none -translate-x-4 -translate-y-8 md:-translate-x-6 md:-translate-y-10 z-0 transition-colors duration-500 group-hover:text-primary/10">
                  {step.number}
                </span>

                {}
                <div className="relative z-10 pl-4 md:pl-6 border-l border-primary/20 group-hover:border-primary/60 transition-colors duration-500">
                  <CardHeader className="p-0 mb-4">
                    <CardTitle className="text-xl md:text-2xl font-serif font-medium text-foreground tracking-tight">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-0">
                    <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                      {step.description}
                    </CardDescription>
                  </CardContent>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}